import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeFixedCost, makeRangeCost, makeVariableCost } from '~/models/service-cost/makers.ts';
import { ServiceCostType } from './model';
import { price } from './pricing';
import * as selectors from './selectors';
export function setPriceIncrease(cost, priceIncrease) {
    return _object_spread_props(_object_spread({}, cost), {
        priceIncrease
    });
}
export function setPreapprovedAmount(cost, amount, controlledByAdvancedSettings) {
    if (cost.pricingType === ServiceCostType.Variable) {
        return _object_spread(_object_spread_props(_object_spread({}, cost), {
            unitCap: amount
        }), controlledByAdvancedSettings ? {
            preapprovedControlledByAdvancedSettings: true
        } : {
            preapprovedControlledByAdvancedSettings: false
        });
    }
    return cost;
}
export function setDiscount(cost, discount) {
    return _object_spread_props(_object_spread({}, cost), {
        discount
    });
}
export function setPrice(cost, newCost) {
    switch(cost.pricingType){
        case ServiceCostType.Fixed:
        case ServiceCostType.Variable:
            return _object_spread_props(_object_spread({}, cost), {
                price: price(newCost)
            });
        case ServiceCostType.Range:
            return _object_spread_props(_object_spread({}, cost), {
                maxPrice: price(newCost),
                minPrice: selectors.minPrice(newCost)
            });
    }
}
export function setPrice2(cost, price) {
    switch(cost.pricingType){
        case ServiceCostType.Fixed:
        case ServiceCostType.Variable:
            return _object_spread_props(_object_spread({}, cost), {
                price
            });
        case ServiceCostType.Range:
            return _object_spread_props(_object_spread({}, cost), {
                maxPrice: price,
                minPrice: cost.minPrice
            });
    }
}
export function inputCostDataToModel(param) {
    let { pricing, price, minPrice, discount, priceIncrease, unitCap, unitName } = param;
    switch(pricing){
        case ServiceCostType.Fixed:
            return makeFixedCost(price, {
                discount,
                priceIncrease
            });
        case ServiceCostType.Range:
            return makeRangeCost(price, {
                minPrice: minPrice ? +minPrice : null,
                discount,
                priceIncrease
            });
        default:
            return makeVariableCost(price, {
                discount,
                unitName: pricing === 'unit' && unitName || null,
                unitCap: unitCap ? +unitCap : 0,
                priceIncrease
            });
    }
}
